var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "default-page vertical-align-center" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-center", attrs: { md: "3" } }, [
                _c(
                  "div",
                  { staticClass: "avatar" },
                  [_c("Avatar", { attrs: { avatar: _vm.avatarCatNotebook } })],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6", "offset-md": "1" } },
                [
                  _c("h1", [_vm._v("Passwort zurücksetzen")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Setz dir ein neues sicheres Passwort:")]),
                  _vm._v(" "),
                  _c("Password", {
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _c("Button", {
                        attrs: {
                          text: "Passwort zurücksetzen",
                          disabled: !_vm.passwordValid || _vm.resetting,
                          loading: _vm.resetting,
                          icon: "checkmark"
                        },
                        on: { click: _vm.reset }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }